import { FormControl, FormLabel, Icon, Tooltip } from '@mui/material';
import { Box } from '@mui/system';

import RadioGroup from 'Lib/muiComponents/common/RadioGroup';

export default function Choice(props) {
    return (
        <FormControl fullWidth>
            <Box alignItems="center" display="flex">
                <FormLabel id="radio-group-choice-filter" variant="list-filter">
                    {props.label}
                </FormLabel>
                {props.tooltip && (
                    <Tooltip title={props.tooltip} arrow>
                        <Icon fontSize={'small'} sx={{ ml: 2, cursor: 'pointer', fontVariationSettings: "'FILL' 1" }}>
                            info
                        </Icon>
                    </Tooltip>
                )}
            </Box>
            <RadioGroup {...props} />
        </FormControl>
    );
}
